import { render } from "./settings_user_management_header.html?vue&type=template&id=62cb1166&external"
import script from "./settings_user_management_header.js?vue&type=script&lang=js&external"
export * from "./settings_user_management_header.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__